const ACCESS_TO_PROFILE = {
  adminAccess: "Admin",
  staffAccess: "Staff",
  userAccess: "User",
  carrierAccess: "Carrier",
  clientAccess: "Client",
};

export function readStoredJson(key) {
  try {
    const raw = localStorage.getItem(key);
    if (raw == null || raw === "" || raw === "undefined" || raw === "null") {
      return null;
    }
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function getSessionUser() {
  return readStoredJson("userDetail");
}

export function getSessionToken() {
  const token = readStoredJson("token");
  if (typeof token === "string" && token.length > 0) return token;
  const authToken = localStorage.getItem("authToken");
  if (authToken && authToken !== "undefined" && authToken !== "null") {
    try {
      const parsed = JSON.parse(authToken);
      if (typeof parsed === "string") return parsed;
    } catch {
      return authToken;
    }
    return authToken;
  }
  return null;
}

export function getSessionProfile() {
  const user = getSessionUser();
  if (user?.profile) return user.profile;
  const access = readStoredJson("access");
  if (typeof access === "string" && ACCESS_TO_PROFILE[access]) {
    return ACCESS_TO_PROFILE[access];
  }
  return null;
}

export function isSessionAuthenticated() {
  return !!(getSessionUser() || getSessionToken());
}

export function clearSession() {
  localStorage.removeItem("userDetail");
  localStorage.removeItem("token");
  localStorage.removeItem("authToken");
  localStorage.removeItem("access");
}

export { ACCESS_TO_PROFILE };
